import { ExternalLink, Newspaper } from 'lucide-react';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { CONTACT, PRESS_BLURB, PRESS_ITEMS } from '../../content/site-pages';

export function PressPage() {
  return (
    <StaticPageLayout title="Press" subtitle="Media resources and news">
      <Card>
        <CardContent className="p-5 space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Newspaper className="h-5 w-5 text-primary" />
            </div>
            <p className="text-sm text-body leading-relaxed">{PRESS_BLURB}</p>
          </div>
        </CardContent>
      </Card>

      <div>
        <h2 className="text-sm font-medium text-body uppercase tracking-wider mb-3 px-1">
          Media inquiries
        </h2>
        <Card>
          <CardContent className="p-5">
            <p className="text-sm text-body mb-2">
              For press requests, interview opportunities, and brand assets:
            </p>
            <a
              href={`mailto:${CONTACT.pressEmail}`}
              className="text-sm font-medium text-primary hover:underline"
            >
              {CONTACT.pressEmail}
            </a>
            <p className="text-xs text-body mt-3">
              Logo usage is permitted for editorial coverage with attribution to Fash.
              Contact us for high-resolution brand assets.
            </p>
          </CardContent>
        </Card>
      </div>

      <div>
        <h2 className="text-sm font-medium text-body uppercase tracking-wider mb-3 px-1">
          In the news
        </h2>
        <Card>
          <CardContent className="p-0 divide-y divide-gray-100">
            {PRESS_ITEMS.map((item) => (
              <div key={item.title} className="p-4">
                <p className="text-xs text-body mb-1">
                  {new Date(item.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                  {' · '}
                  {item.outlet}
                </p>
                {item.url ? (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm font-medium text-heading hover:text-primary"
                  >
                    {item.title}
                    <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                ) : (
                  <p className="text-sm font-medium text-heading">{item.title}</p>
                )}
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </StaticPageLayout>
  );
}
